export default __webpack_public_path__ + "static/media/video.b8e9dd92.png";